import { render, staticRenderFns } from "./DefaultRowActions.vue?vue&type=template&id=1cc61ad0&scoped=true"
import script from "./DefaultRowActions.vue?vue&type=script&lang=js"
export * from "./DefaultRowActions.vue?vue&type=script&lang=js"
import style0 from "./DefaultRowActions.vue?vue&type=style&index=0&id=1cc61ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc61ad0",
  null
  
)

export default component.exports